import {h, Component} from 'preact';
import Provider from 'preact-context-provider';
import cx from 'classnames';
import includes from 'ramda/src/includes';
import Icon from '@components/common/Icon';
import Modal from 'react-modal';
import invoke from 'lodash.invoke';
import {SmallDevice, MediumDevice} from '@components/common/MediaQueries';

function safeSize ( size ) {
    const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
    if ( includes( size, sizes ) ) {
        return `max-w-${size}`;
    }
    return `max-w-sm`;
}

const MODAL_CONTAIN_VERT = 'flex h-full flex-col justify-center';
const MODAL_CONTAIN_HORZ = 'flex flex-col h-full md:h-auto';
const MODAL_CONTENT = 'w-full h-full mx-auto bg-white md:my-12 md:shadow-1-strong md:rounded md:overflow-hidden md:static md:h-auto md:bg-transparent';
const MODAL_HEADER_MOBILE = 'z-1 w-full flex justify-between items-center fixed text-base bg-white p-4 border-b border-solid border-grey-lighter';
const MODAL_HEADER_DESKTOP = 'modal-header flex w-full items-center justify-between';

const docEl = document.getElementById( 'top' );

class UPIModal extends Component {
    static defaultProps = {
        id: 'UPI_MODAL'
    };

    componentDidMount () {
        const {printOnly, isOpen} = this.props;
        if ( printOnly && isOpen === true ) {
            document.documentElement.classList.add( 'modal-print-only' );
        }
    }

    componentWillReceiveProps ( nextProps, nextContext ) {
        if ( nextProps.isOpen !== this.props.isOpen ) {
            const docEl = document.documentElement;
            if ( nextProps.isOpen ) {
                docEl.classList.add( 'no-scroll' );
                if ( nextProps.printOnly ) {
                    docEl.classList.add( 'modal-print-only' );
                }
            }
            else {
                docEl.classList.remove( 'no-scroll' );
                docEl.classList.remove( 'modal-print-only' );
            }
        }
    }

    // height: 100%;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    render ( {children, ...props} ) {
        const onClose = () => invoke( props, 'onClose', props.id );
        const isClosable = typeof props.onClose === 'function';
        const modalTitle = props.title || '';
        const sizeClass = safeSize( props.size );

        // <div className="flex-auto"> need to be set to height:100vh for mobile
        return (
            <Provider onClose={onClose}>
                <Modal
                    id={props.id}
                    appElement={docEl}
                    onRequestClose={onClose}
                    className={cx( `md:${sizeClass}`, 'mx-auto' )}
                    {...props}>
                    <div className="flex-auto h-screen md:h-auto">
                        <div className={MODAL_CONTAIN_VERT}>
                            <div className={MODAL_CONTAIN_HORZ}>
                                <div className={cx( `md:${sizeClass}`, MODAL_CONTENT )}>
                                    <SmallDevice>
                                        <header className={MODAL_HEADER_MOBILE}>
                                            {isClosable
                                                ?
                                                <span className="flex items-center flex-0 w-8 link-2" onClick={onClose}>
                                                    <Icon.ui name="arrow-left" className="text-lg mr-2"/>
                                                    Back
                                                </span>
                                                :
                                                <span className="flex-0 w-8"/>
                                            }
                                            <h2 className="h1 font-normal px-4 ellipsis">{modalTitle}</h2>
                                            <span className="flex-0 w-8"/>
                                        </header>
                                    </SmallDevice>
                                    <MediumDevice>
                                        <header className={MODAL_HEADER_DESKTOP}>
                                            <h2 className="text-xl font-normal">{modalTitle}</h2>
                                            {isClosable &&
                                            <Icon.ui className="cursor-pointer" name={'remove'} onClick={onClose}/>
                                            }
                                        </header>
                                    </MediumDevice>
                                    <section className={cx( sizeClass, 'modal-body mx-auto mt-12 md:mt-0' )}>
                                        {children}
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </Provider>
        );
    }
}

export default UPIModal;